/* Long-form prose wrapper used by Privacy / Terms / Contact / Pricing pages.
 *
 * Provides editorial-calm styling for article content (h1, h2, h3, p, ul, a)
 * via the dash-prose-* class system; pages only need to write semantic markup.
 */
import React from 'react';
import { mono, sans, ivory, muted } from './EditorialShell';

import '../../assets/scss/editorial-prose.scss';

interface EditorialArticleProps {
    eyebrow?: string;
    title: string;
    subtitle?: string;
    children: React.ReactNode;
    /** Optional max-width override, defaults to 820. */
    maxWidth?: number;
}

const EditorialArticle: React.FC<EditorialArticleProps> = ({
    eyebrow,
    title,
    subtitle,
    children,
    maxWidth = 820,
}) => (
    <article
        className="ed-prose"
        style={{
            maxWidth,
            margin: '0 auto',
            padding: 'clamp(48px, 8vw, 96px) clamp(20px, 4vw, 40px) clamp(64px, 10vw, 120px)',
            fontFamily: sans,
        }}
    >
        {eyebrow && (
            <div
                style={{
                    fontSize: 11,
                    letterSpacing: '0.24em',
                    color: muted,
                    fontFamily: mono,
                    fontWeight: 500,
                    marginBottom: 18,
                }}
            >
                {eyebrow}
            </div>
        )}

        <h1
            className="ed-prose__title"
            style={{
                fontSize: 'clamp(36px, 6vw, 64px)',
                fontWeight: 200,
                color: ivory,
                letterSpacing: '-0.035em',
                lineHeight: 1.05,
                margin: '0 0 16px',
            }}
        >
            {title}
        </h1>

        {subtitle && (
            <p
                style={{
                    fontSize: 16,
                    color: muted,
                    lineHeight: 1.6,
                    margin: '0 0 28px',
                    fontFamily: sans,
                }}
            >
                {subtitle}
            </p>
        )}

        <div style={{ height: 1, background: 'rgba(232, 230, 224, 0.08)', margin: '24px 0 32px' }} />

        <div className="ed-prose__body">{children}</div>
    </article>
);

export default EditorialArticle;
